import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/reports/v1`;

export function getDailyLeaveStatus({ search = "", date = "" }) {
  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: `${url}/daily_leave_status?search=${search}&date=${date}`,
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getLeaveBalance({ employeeId, isExport = false }) {
  let newUrl = `${getURl()}/reports/v1/leave_balance`;
  if (employeeId)
    newUrl = `${getURl()}/reports/v1/leave_balance?employeeId=${employeeId}&isExport=${isExport}`;
  const result = axios({
    method: "GET",
    url: newUrl,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getLeaveBookBalance({ employeeId = "", date = "", isExport = false,offset=0}) {
  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: `${url}/booked_balance?employeeId=${employeeId}&date=${date}&isExport=${isExport}&offset=${offset}`,
  });

  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}
